import { find } from 'linkifyjs';
import { useEffect, useMemo, useRef } from 'react';
import { PaperLink } from 'js/social/shared/types';
import { serializePaperLink, normalizePaperLink } from './utils';

export function usePaperLinkDetection(
  content: string,
  onChange: (newLinks: PaperLink[], removedLinks: PaperLink[]) => void,
) {
  const paperLinks = useRef<string[]>([]);

  const linkRegex = useMemo(() => {
    const domainParts = location.hostname.split('.');
    const domain = domainParts
      .slice(Math.max(0, domainParts.length - 2), domainParts.length)
      .join('\\.');
    return new RegExp(`^https?://(\\w+\\.)?${domain}/(\\d+)`);
  }, []);

  useEffect(() => {
    const currentLinks = find(content)
      .map(({ value }) => value.match(linkRegex))
      .filter(Boolean)
      // We know there's a match at this point, so the null checks make TS happy
      .map((match) => ({
        id: parseInt(match?.[2] || '0'),
        slug: match?.[3] || '',
      }))
      .map(serializePaperLink);
    const currentLinksSet = new Set(currentLinks);
    const paperLinksSet = new Set(paperLinks.current);

    const newLinks = currentLinks.filter((link) => !paperLinksSet.has(link));
    const removedLinks = paperLinks.current.filter(
      (link) => !currentLinksSet.has(link),
    );
    onChange(
      newLinks.map(normalizePaperLink),
      removedLinks.map(normalizePaperLink),
    );

    paperLinks.current = currentLinks;
  }, [paperLinks, linkRegex, content, onChange]);
}
